var _a;
export const id = Symbol.for("id");
export const isBrowserWindow = typeof window === "object"
    && typeof window.document === "object"
    && typeof window.matchMedia === "function";
export const isServiceWorker = typeof ServiceWorkerGlobalScope === "function"
    && globalThis instanceof ServiceWorkerGlobalScope;
export const isSharedWorker = typeof SharedWorkerGlobalScope === "function"
    && globalThis instanceof SharedWorkerGlobalScope;
export const isDedicatedWorker = typeof DedicatedWorkerGlobalScope === "function"
    && globalThis instanceof DedicatedWorkerGlobalScope;
export const isWorker = isServiceWorker || isSharedWorker || isDedicatedWorker;
export const isDeno = typeof Deno === "object" && typeof Deno.version === "object";
export const isBun = typeof Bun === "object" && typeof Bun.version === "string";
export const isNodeLike = typeof process === "object" && !!((_a = process.versions) === null || _a === void 0 ? void 0 : _a.node) && !isDeno;
export const isNode = isNodeLike && !isDeno && !isBun;
export const isNodeBelow14 = isNode && parseInt(process.version.slice(1)) < 14;
export const isNodeBelow16 = isNode && parseInt(process.version.slice(1)) < 16;
export const isNodeBelow20 = isNode && parseInt(process.version.slice(1)) < 20;
const isNodeWorkerThread = isNode
    && (process.abort.disabled === true || process.argv.includes("--worker-thread"));
export const isMainThread = !isNodeWorkerThread
    && (isBun ? Bun.isMainThread : typeof WorkerGlobalScope === "undefined");
//# sourceMappingURL=env.js.map